'use client'

import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import {
  LoginRegistrationUserLoginStateProvider,
  useApiSwrGetCustomerPreferredLanguage,
  useLoginRegistrationGtmPushFullStoryTracking,
} from '../../login-registration'
import { SeoHeadTitleMetas } from '../../seo'

import { LoginRegistrationFooter } from './LoginRegistrationFooter/LoginRegistrationFooter'
import { LoginRegistrationLoginSection } from './LoginRegistrationLoginSection'
import { LoginRegistrationRegistrationSection } from './LoginRegistrationRegistrationSection'

type LoginRegistrationPageProps = {
  guestEmail?: string
}

export const LoginRegistrationPage: FC<LoginRegistrationPageProps> = ({
  guestEmail,
}) => {
  const intl = useIntl()
  useApiSwrGetCustomerPreferredLanguage()

  useLoginRegistrationGtmPushFullStoryTracking(false)

  return (
    <div data-qa-id="login-registration-page">
      <SeoHeadTitleMetas
        title={intl.formatMessage({ id: 'general.label.loginOrRegister' })}
      />
      <div className="flex h-full flex-col justify-between tablet:bg-light-primary-medium">
        <div className="pb-16">
          <h1 className="mb-6 hidden pt-8 text-center text-2xl font-medium tablet:block">
            <FormattedMessage id="general.link.label.login" />
          </h1>
          <div className="mx-auto flex max-w-5xl flex-col tablet:flex-row">
            <LoginRegistrationUserLoginStateProvider guestEmail={guestEmail}>
              <LoginRegistrationLoginSection />
            </LoginRegistrationUserLoginStateProvider>
            <LoginRegistrationRegistrationSection />
          </div>
        </div>
        <LoginRegistrationFooter />
      </div>
    </div>
  )
}
